import { Controller } from '@hotwired/stimulus';

// Narrows the (very long) channel checkbox list as you type. Pure client-side
// filtering of the already-rendered options — no extra request, no backend.
export default class extends Controller {
  static targets = ['input', 'option', 'empty'];

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();
    let visible = 0;

    this.optionTargets.forEach((option) => {
      const match = query === '' || option.textContent.toLowerCase().includes(query);
      option.classList.toggle('hidden', !match);
      if (match) visible += 1;
    });

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle('hidden', visible !== 0);
    }
  }

  // The input lives inside the filter form; don't let Enter submit/reload it.
  stopEnter(event) {
    event.preventDefault();
  }
}
